export default __webpack_public_path__ + "static/media/Download.53c8ea25.svg";